/** @jsxImportSource @emotion/react */
import { Interpolation, Theme } from '@emotion/react';
import { ReactNode } from 'react';
import { useTheme } from '../../';

interface Props {
  children: ReactNode;
  className?: string;
  css?: Interpolation<Theme>;
  testId?: string;
}

export const List = ({ children, className, testId, css }: Props) => {
  const { spacing, palette, shape } = useTheme();
  return (
    <ul
      data-testid={testId}
      className={className}
      css={[
        {
          listStyleType: 'none',
          margin: 0,
          padding: 0,
          background: palette.white,
          minWidth: spacing.xxxl,
          borderRadius: shape.borderRadius,
          border: `1px solid ${palette.grey.x100}`,
          '> *': {
            borderTop: `1px solid ${palette.grey.x100}`,
            '&:first-of-type': {
              border: 0,
            },
          },
        },
        css,
      ]}
    >
      {children}
    </ul>
  );
};
